<template>
    <resolver :model="model" v-if="!model.disabled" />
</template>

<style scoped>
.heading-icon {
    text-align: center;
}
</style>

<script>
import Resolver from "./Resolver"
export default {
    name: 'Settings',
    components: {
        Resolver
    },
    props: {
        model: {
            Type: Object,
            default: function() {
                return null
            }
        }
    },
    data: function() {
        return {}
    },
    computed: {
        integration() {
            if (this.model) return this.model

            return integrations.find(i => {
                return !i.disabled
            })
        }
    },
    methods: {},
    mounted() {}
}
</script>